import { Injectable } from '@angular/core';
import { Converter } from '../../converter.interface';
import { isNullOrUndefined } from 'util';
import { OrderDetailsServicesObject } from 'src/app/models/orders/order-details-services/order-details-services-object.model';
import { StringUtils } from 'src/app/services/utils/string.utils';

@Injectable({
    providedIn: 'root'
})
export class OrderDetailsServicesConverter implements Converter<OrderDetailsServicesObject> {

    constructor() { }

    convert(input: any): OrderDetailsServicesObject {
        if (isNullOrUndefined(input)) {
            return OrderDetailsServicesObject.create();
        }
        return new OrderDetailsServicesObject(StringUtils.default(input.action), StringUtils.default(input.name),
            StringUtils.default(input.specification), StringUtils.default(input.id));
    }
}
